skrilla.directive('queryProductIntegrityReports', function () {
    return {
        templateUrl: 'directives/productIntegrityReports/queryProductIntegrityReports.html',
        scope: {
            reports: "=",
            key: "=",
            queryKey: "=",
            selectedReports: "=" //the output of rows selected with checkboxes
        },
        controller: async function ($scope, searchService, queryService, paginationService, cacheService, modalService) {
            $scope.tags = cacheService.getObject("productIntegrityTags");
            $scope.reportTypes = ["SUSPICIOUS_BET_AMOUNTS","EVENT_ANALYSIS"];
            if($scope.tags === null || $scope.tags === undefined){
                searchService.get("betting/events/productFeeTagTypes").then(function(response){
                    $scope.tags = response.data;
                    var subs = [];
                    $scope.tags.forEach(function(tag){
                        subs = subs.concat(tag.second);
                    });
                    $scope.tags = $scope.tags.filter(function(tag){
                        return !subs.includes(tag.first);
                    })
                    cacheService.registerObject("productIntegrityTags", $scope.tags);
                });
            }

            $scope.reset = function () {
                $scope.query = {
                    limit: 20,
                    sortOrder: 'DESC',
                    reportType: null
                };
                return $scope.query;
            };
            $scope.query = cacheService.getObjectOrElse($scope.queryKey, $scope.reset)


            $scope.search = function () {
                paginationService.resetPage($scope.key);
                paginationService.pageQuery(getReports, $scope.key);
            }

            $scope.tennis = function(){
                modalService.confirm("Are you sure?", function(){
                    searchService.post("productIntegrityReports", null, "Success").then(function (response) {

                    });
                })
            }

            var getReports = function () {
                cacheService.registerObject($scope.queryKey, $scope.query)
                return searchService.get("productIntegrityReports" + queryService.getQueryString($scope.query, $scope.key)).then(function (response) {
                    $scope.reports = response.data.result;
                    $scope.selectedReports = [];
                    cacheService.registerObject("productIntegrityReportsTable", $scope.reports);
                    paginationService.setPage($scope.key, paginationService.buildPage(response));
                });
            }

            $scope.btnPress = function (keyEvent) {
                if (keyEvent.which === 13)
                    $scope.search();
            }
        }
    };
});
